import { ErrorCode } from '@dokucoach/common-types';

export const ERROR_CODES = Object.freeze({ FORBIDDEN: 'Forbidden' });

export const errorMessages = new Map<ErrorCode, string>([
  [ErrorCode.ADDRESS_DATA_NOT_FOUND, 'error_addressDataNotFound'],
  [ErrorCode.SUGGESTION_NOT_FOUND, 'error_suggestionNotFound'],
  [ErrorCode.ADDRESS_DATA_CAN_NOT_BE_CREATED, 'error_addressDataCannotBeCreated'],
  [ErrorCode.ADDRESS_DATA_CAN_NOT_BE_UPDATED, 'error_addressDataCannotBeUpdated'],
  [ErrorCode.ADDRESS_DATA_CAN_NOT_BE_DELETED, 'error_addressDataCannotBeDeleted'],
  [ErrorCode.ADDRESS_DATA_CAN_NOT_BE_RESTORED, 'error_addressDataCannotBeRestored'],
  [ErrorCode.BIOGRAPHY_NOT_FOUND, 'error_biographyNotFound'],
  [ErrorCode.BIOGRAPHY_CAN_NOT_BE_CREATED, 'error_biographyCannotBeCreated'],
  [ErrorCode.BIOGRAPHY_CAN_NOT_BE_UPDATED, 'error_biographyCannotBeUpdated'],
  [ErrorCode.BIOGRAPHY_CAN_NOT_BE_DELETED, 'error_biographyCannotBeDeleted'],
  [ErrorCode.CARE_PLAN_NOT_FOUND, 'error_carePlanNotFound'],
  [ErrorCode.CARE_PLAN_CAN_NOT_BE_CREATED, 'error_carePlanCannotBeCreated'],
  [ErrorCode.CARE_PLAN_CAN_NOT_BE_UPDATED, 'error_carePlanCannotBeUpdated'],
  [ErrorCode.CARE_PLAN_CAN_NOT_BE_DELETED, 'error_carePlanCannotBeDeleted'],
  [ErrorCode.CLIENT_NOT_FOUND, 'error_clientNotFound'],
  [ErrorCode.CLIENT_CAN_NOT_BE_CREATED, 'error_clientCannotBeCreated'],
  [ErrorCode.CLIENT_CAN_NOT_BE_UPDATED, 'error_clientCannotBeUpdated'],
  [ErrorCode.CLIENT_CAN_NOT_BE_DELETED, 'error_clientCannotBeDeleted'],
  [ErrorCode.COMMUNICATION_DATA_NOT_FOUND, 'error_communicationDataNotFound'],
  [ErrorCode.COMMUNICATION_DATA_CAN_NOT_BE_CREATED, 'error_communicationDataCannotBeCreated'],
  [ErrorCode.COMMUNICATION_DATA_CAN_NOT_BE_UPDATED, 'error_communicationDataCannotBeUpdated'],
  [ErrorCode.COMMUNICATION_DATA_CAN_NOT_BE_DELETED, 'error_communicationDataCannotBeDeleted'],
  [ErrorCode.COMMUNICATION_DATA_CAN_NOT_BE_RESTORED, 'error_communicationDataCannotBeRestored'],
  [ErrorCode.CONSULTATION_NOT_FOUND, 'error_consultationNotFound'],
  [ErrorCode.CONSULTATION_CAN_NOT_BE_CREATED, 'error_consultationCannotBeCreated'],
  [ErrorCode.CONSULTATION_CAN_NOT_BE_UPDATED, 'error_consultationCannotBeUpdated'],
  [ErrorCode.CONSULTATION_CAN_NOT_BE_DELETED, 'error_consultationCannotBeDeleted'],
  [ErrorCode.CONTACT_DATA_NOT_FOUND, 'error_contactDataNotFound'],
  [ErrorCode.CONTACT_DATA_CAN_NOT_BE_CREATED, 'error_contactDataCannotBeCreated'],
  [ErrorCode.CONTACT_DATA_CAN_NOT_BE_UPDATED, 'error_contactDataCannotBeUpdated'],
  [ErrorCode.CONTACT_DATA_CAN_NOT_BE_DELETED, 'error_contactDataCannotBeDeleted'],
  [ErrorCode.CONTACT_DATA_CAN_NOT_BE_RESTORED, 'error_contactDataCannotBeRestored'],
  [ErrorCode.DECUBITUS_RISK_FORM_NOT_FOUND, 'error_decubitusRiskFormNotFound'],
  [ErrorCode.DECUBITUS_RISK_FORM_CAN_NOT_BE_CREATED, 'error_decubitusRiskFormCannotBeCreated'],
  [ErrorCode.DECUBITUS_RISK_FORM_CAN_NOT_BE_UPDATED, 'error_decubitusRiskFormCannotBeUpdated'],
  [ErrorCode.DECUBITUS_RISK_FORM_CAN_NOT_BE_DELETED, 'error_decubitusRiskFormCannotBeRestored'],
  [ErrorCode.DOCTOR_NOT_FOUND, 'error_doctorNotFound'],
  [ErrorCode.DOCTOR_CAN_NOT_BE_CREATED, 'error_doctorCannotBeCreated'],
  [ErrorCode.DOCTOR_DIAGNOSIS_NOT_FOUND, 'error_doctorDiagnosisNotFound'],
  [ErrorCode.DOCTOR_DIAGNOSIS_CAN_NOT_BE_CREATED, 'error_doctorDiagnosisCannotBeCreated'],
  [ErrorCode.EMPLOYEE_BASE_DATA_NOT_FOUND, 'error_employeeBaseDataNotFound'],
  [ErrorCode.EMPLOYEE_BASE_DATA_CAN_NOT_BE_CREATED, 'error_employeeBaseDataCannotBeCreated'],
  [ErrorCode.EMPLOYEE_BASE_DATA_CAN_NOT_BE_UPDATED, 'error_employeeBaseDataCannotBeUpdated'],
  [ErrorCode.EMPLOYEE_BASE_DATA_CAN_NOT_BE_DELETED, 'error_employeeBaseDataCannotBeDeleted'],
  [ErrorCode.EMPLOYEE_BASE_DATA_CAN_NOT_BE_RESTORED, 'error_employeeBaseDataCannotBeRestored'],
  [ErrorCode.EMPLOYEE_NOT_FOUND, 'error_employeeNotFound'],
  [ErrorCode.EMPLOYEE_CAN_NOT_BE_CREATED, 'error_employeeCannotBeCreated'],
  [ErrorCode.EMPLOYEE_CAN_NOT_BE_UPDATED, 'error_employeeCannotBeUpdated'],
  [ErrorCode.EMPLOYEE_CAN_NOT_BE_DELETED, 'error_employeeCannotBeDeleted'],
  [ErrorCode.EMPLOYEE_CAN_NOT_BE_RESTORED, 'error_employeeCannotBeRestored'],
  [ErrorCode.EMPLOYEE_CONTRACT_CHECKLIST_NOT_FOUND, 'error_employeeContractChecklistNotFound'],
  [ErrorCode.EMPLOYEE_ALREADY_EXISTS_IN_TIMEOS, 'error_employeeAlreadyExistsInTimeos'],
  [ErrorCode.EMPLOYEE_COULD_NOT_BE_CREATED_IN_TIMEOS, 'error_employeeCouldNotBeCreatedInTimeos'],
  [
    ErrorCode.EMPLOYEE_LOGIN_CREDENTIALS_COULD_NOT_BE_SET_IN_TIMEOS,
    'error_employeeLoginCredentialsCouldNotBeSetInTimeos',
  ],
  [ErrorCode.EMPLOYEE_COULD_NOT_BE_UPDATED_IN_TIMEOS, 'error_employeeCouldNotBeUpdatedInTimeos'],
  [ErrorCode.EMPLOYEE_COULD_NOT_BE_DELETED_IN_TIMEOS, 'error_employeeCouldNotBeDeletedInTimeos'],
  [ErrorCode.EMPLOYEE_COULD_NOT_BE_RESTORED_IN_TIMEOS, 'error_employeeCouldNotBeRestoredInTimeos'],
  [
    ErrorCode.EMPLOYEE_QUALIFICATION_COULD_NOT_BE_ADDED_IN_TIMEOS,
    'error_employeeQualificationCouldNotBeAddedInTimeos',
  ],
  [ErrorCode.FALL_NOT_FOUND, 'error_fallNotFound'],
  [ErrorCode.FALL_CAN_NOT_BE_CREATED, 'error_fallCannotBeCreated'],
  [ErrorCode.FALL_CAN_NOT_BE_UPDATED, 'error_fallCannotBeUpdated'],
  [ErrorCode.FALL_CAN_NOT_BE_DELETED, 'error_fallCannotBeDeleted'],
  [ErrorCode.FALL_RISK_FORM_NOT_FOUND, 'error_fallRiskFormNotFound'],
  [ErrorCode.FALL_RISK_FORM_CAN_NOT_BE_UPDATED, 'error_fallRiskFormCannotBeUpdated'],
  [ErrorCode.FALL_RISK_FORM_CAN_NOT_BE_CREATED, 'error_fallRiskFormCannotBeCreated'],
  [ErrorCode.FALL_PROTOCOL_FORM_NOT_FOUND, 'error_fallProtocolNotFound'],
  [ErrorCode.FALL_PROTOCOL_FORM_CAN_NOT_BE_CREATED, 'error_fallProtocolCannotBeCreated'],
  [ErrorCode.FALL_PROTOCOL_FORM_CAN_NOT_BE_UPDATED, 'error_fallProtocolCannotBeUpdated'],
  [ErrorCode.FALL_PROTOCOL_FORM_CAN_NOT_BE_DELETED, 'error_fallProtocolCannotBeDeleted'],
  [ErrorCode.INSURANCE_NOT_FOUND, 'error_insuranceNotFound'],
  [ErrorCode.INSURANCE_CAN_NOT_BE_DELETED_AS_IN_USE, 'error_insuranceCanNotBeDeltedAsInUse'],
  [ErrorCode.INSURANCE_DELETION_FAILED, 'error_insuranceDeletionFailed'],
  [ErrorCode.NAME_NOT_FOUND, 'error_nameNotFound'],
  [ErrorCode.NAME_CAN_NOT_BE_CREATED, 'error_nameCannotBeCreated'],
  [ErrorCode.NAME_CAN_NOT_BE_UPDATED, 'error_nameCannotBeUpdated'],
  [ErrorCode.NAME_CAN_NOT_BE_DELETED, 'error_nameCannotBeDeleted'],
  [ErrorCode.NAME_CAN_NOT_BE_RESTORED, 'error_nameCannotBeRestored'],
  [ErrorCode.NURSING_HOME_NOT_FOUND, 'error_nursingHomeNotFound'],
  [ErrorCode.NURSING_HOME_NOT_FOUND_BY_CLIENT_ID, 'error_nursingHomeNotFoundByClientId'],
  [ErrorCode.NURSING_HOME_CAN_NOT_BE_CREATED, 'error_nursingHomeCannotBeCreated'],
  [ErrorCode.PERSONAL_DATA_NOT_FOUND, 'error_personalDataNotFound'],
  [ErrorCode.PERSONAL_DATA_CAN_NOT_BE_CREATED, 'error_personalDataCannotBeCreated'],
  [ErrorCode.PERSONAL_DATA_CAN_NOT_BE_UPDATED, 'error_personalDataCannotBeUpdated'],
  [ErrorCode.PERSONAL_DATA_CAN_NOT_BE_DELETED, 'error_personalDataCannotBeDeleted'],
  [ErrorCode.PERSONAL_DATA_CAN_NOT_BE_RESTORED, 'error_personalDataCannotBeRestored'],
  [ErrorCode.RESIDENT_NOT_FOUND, 'error_residentNotFound'],
  [ErrorCode.RESIDENT_CAN_NOT_BE_CREATED, 'error_residentCannotBeCreated'],
  [ErrorCode.RESIDENT_CAN_NOT_BE_UPDATED, 'error_residentCannotBeUpdated'],
  [ErrorCode.RESIDENT_CAN_NOT_BE_DELETED, 'error_residentCannotBeDeleted'],
  [ErrorCode.RESIDENT_CAN_NOT_BE_RESTORED, 'error_residentCannotBeRestored'],
  [ErrorCode.RESIDENT_BASE_DATA_NOT_FOUND, 'error_residentBaseDataNotFound'],
  [ErrorCode.RESIDENT_BASE_DATA_CAN_NOT_BE_CREATED, 'error_residentBaseDataCannotBeCreated'],
  [ErrorCode.RESIDENT_BASE_DATA_CAN_NOT_BE_UPDATED, 'error_residentBaseDataCannotBeUpdated'],
  [ErrorCode.RESIDENT_BASE_DATA_CAN_NOT_BE_DELETED, 'error_residentBaseDataCannotBeDeleted'],
  [ErrorCode.RESIDENT_BASE_DATA_CAN_NOT_BE_RESTORED, 'error_residentBaseDataCannotBeRestored'],
  [ErrorCode.INTERRUPTION_NOT_FOUND, 'error_interruptionNotFound'],
  [ErrorCode.HOUSE_DIVISION_CAN_NOT_BE_CREATED, 'error_houseDivisionCannotBeCreated'],
  [ErrorCode.HOUSE_DIVISION_CAN_NOT_BE_FOUND, 'error_houseDivisionCannotBeFound'],
  [ErrorCode.HOUSE_DIVISION_CAN_NOT_BE_UPDATED, 'error_houseDivisionCannotBeUpdated'],
  [ErrorCode.HOUSE_DIVISION_CAN_NOT_BE_DELETED, 'error_houseDivisionCannotBeDeleted'],
  [ErrorCode.LABEL_COULD_NOT_BE_GENERATED, 'error_labelCouldNotBeGenerated'],
  [ErrorCode.RESIDENT_CAN_ONLY_BE_ATTACHED_TO_BED, 'error_residentCanOnlyBeAttachedToBed'],
  [ErrorCode.VITALE_NOT_FOUND, 'error_vitaleNotFound'],
  [ErrorCode.VITALE_CAN_NOT_BE_CREATED, 'error_vitaleCannotBeCreated'],
  [ErrorCode.VITALE_CAN_NOT_BE_UPDATED, 'error_vitaleCannotBeUpdated'],
  [ErrorCode.VITALE_CAN_NOT_BE_DELETED, 'error_vitaleCannotBeDeleted'],
  [
    ErrorCode.RESIDENT_CAN_NOT_BE_ADDED_TO_RESIDENT_GROUP,
    'error_residentCannotBeAddedToResidentGroup',
  ],
  [ErrorCode.USER_NOT_FOUND, 'error_userNotFound'],
  [ErrorCode.USER_CAN_NOT_BE_CREATED, 'error_userCannotBeCreated'],
  [ErrorCode.USER_CAN_NOT_BE_UPDATED, 'error_userCannotBeUpdated'],
  [ErrorCode.USER_CAN_NOT_BE_DELETED, 'error_userCannotBeDeleted'],
  [ErrorCode.USER_CAN_NOT_BE_RESTORED, 'error_userCannotBeRestored'],
  [ErrorCode.PASSWORD_CAN_NOT_BE_SET, 'error_passwordCannotBeSet'],
  [ErrorCode.PASSWORD_CAN_NOT_BE_RESET, 'error_passwordCannotBeReset'],
  [ErrorCode.PIN_CAN_NOT_BE_SET, 'error_pinCannotBeSet'],
  [ErrorCode.SYSTEM_ACCESS_CAN_NOT_BE_UPDATED, 'error_systemAccessCannotBeUpdated'],
  [ErrorCode.SUPERVISOR_DATA_NOT_FOUND, 'error_supervisorDataNotFound'],
  [ErrorCode.SUPERVISOR_DATA_CAN_NOT_BE_CREATED, 'error_supervisorDataCannotBeCreated'],
  [ErrorCode.SUPERVISOR_DATA_CAN_NOT_BE_UPDATED, 'error_supervisorDataCannotBeUpdated'],
  [ErrorCode.SUPERVISOR_DATA_CAN_NOT_BE_DELETED, 'error_supervisorDataCannotBeDeleted'],
  [ErrorCode.RELATIVE_CARE_IDS_COULD_NOT_BE_SAVED, 'error_relativeCareIdsCouldNotBeSaved'],
  [ErrorCode.RELATIVE_MANDATE_IDS_COULD_NOT_BE_SAVED, 'error_relativeMandateIdsCouldNotBeSaved'],
  [ErrorCode.RELATIVE_MANDATE_NOT_FOUND, 'error_relativeMandateNotFound'],
  [ErrorCode.RELATIVE_MANDATE_CAN_NOT_BE_CREATED, 'error_relativeMandateCannotBeCreated'],
  [ErrorCode.RELATIVE_MANDATE_CAN_NOT_BE_UPDATED, 'error_relativeMandateCannotBeUpdated'],
  [ErrorCode.RELATIVE_MANDATE_CAN_NOT_BE_DELETED, 'error_relativeMandateCannotBeDeleted'],
  [ErrorCode.RELATIVE_CONTACT_NOT_FOUND, 'error_relativeContactNotFound'],
  [ErrorCode.RELATIVE_CONTACT_CAN_NOT_BE_CREATED, 'error_relativeContactCannotBeCreated'],
  [ErrorCode.RELATIVE_CONTACT_CAN_NOT_BE_UPDATED, 'error_relativeContactCannotBeUpdated'],
  [ErrorCode.RELATIVE_CONTACT_CAN_NOT_BE_DELETED, 'error_relativeContactCannotBeDeleted'],
  [ErrorCode.RELATIVE_CARE_NOT_FOUND, 'error_relativeCareNotFound'],
  [ErrorCode.RELATIVE_CARE_CAN_NOT_BE_CREATED, 'error_relativeCareCannotBeCreated'],
  [ErrorCode.RELATIVE_CARE_CAN_NOT_BE_UPDATED, 'error_relativeCareCannotBeUpdated'],
  [ErrorCode.RELATIVE_CARE_CAN_NOT_BE_DELETED, 'error_relativeCareCannotBeDeleted'],
  [
    ErrorCode.RESIDENT_CAN_NOT_BE_ADDED_TO_RESIDENT_GROUP,
    'error_residentCannotBeAddedToResidentGroup',
  ],
  [ErrorCode.SOCIAL_CARE_EVENT_NOT_FOUND, 'error_socialCareEventNotFound'],
  [ErrorCode.SOCIAL_CARE_EVENT_CAN_NOT_BE_CREATED, 'error_socialCareEventCannotBeCreated'],
  [ErrorCode.SOCIAL_CARE_EVENT_CAN_NOT_BE_UPDATED, 'error_socialCareEventCannotBeUpdated'],
  [ErrorCode.SOCIAL_CARE_EVENT_CAN_NOT_BE_DELETED, 'error_socialCareEventCannotBeDeleted'],
  [ErrorCode.SOCIAL_CARE_EVENT_DOCUMENT_NOT_FOUND, 'error_socialCareEventDocumentNotFound'],
  [
    ErrorCode.SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_CREATED,
    'error_socialCareEventDocumentCannotBeCreated',
  ],
  [
    ErrorCode.SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_UPDATED,
    'error_socialCareEventDocumentCannotBeUpdated',
  ],
  [
    ErrorCode.SOCIAL_CARE_EVENT_DOCUMENT_CAN_NOT_BE_DELETED,
    'error_socialCareEventDocumentCannotBeDeleted',
  ],
  [ErrorCode.INPUT_MALFORMED, 'error_inputMalformed'],

  [ErrorCode.VITAL_SIGN_NOT_FOUND, 'error_vitalSignNotFound'],
  [ErrorCode.VITAL_SIGN_CAN_NOT_BE_CREATED, 'error_vitalSignCannotBeCreated'],
  [ErrorCode.VITAL_SIGN_CAN_NOT_BE_UPDATED, 'error_vitalSignCannotBeUpdated'],
  [ErrorCode.VITAL_SIGN_CAN_NOT_BE_DELETED, 'error_vitalSignCannotBeDeleted'],
  [ErrorCode.PRESCRIPTION_NOT_FOUND, 'error_prescriptionNotFound'],
  [ErrorCode.PRESCRIPTION_CAN_NOT_BE_CREATED, 'error_prescriptionCannotBeCreated'],
  [ErrorCode.PERSONAL_DATA_CAN_NOT_BE_UPDATED, 'error_prescriptionCannotBeUpdated'],
  [ErrorCode.PRESCRIPTION_CAN_NOT_BE_DELETED, 'error_prescriptionCannotBeDeleted'],
  [ErrorCode.NUTRITION_PROTOCOL_NOT_FOUND, 'error_nutritionProtocolNotFound'],
  [ErrorCode.NUTRITION_PROTOCOL_CAN_NOT_BE_CREATED, 'error_nutritionProtocolCannotBeCreated'],
  [ErrorCode.NUTRITION_PROTOCOL_CAN_NOT_BE_UPDATED, 'error_nutritionProtocolCannotBeUpdated'],
  [ErrorCode.NUTRITION_PROTOCOL_CAN_NOT_BE_DELETED, 'error_nutritionProtocolCannotBeDeleted'],
  [ErrorCode.LIQUID_OUTPUT_CAN_NOT_BE_UPDATED, 'error_liquidOutputCannotBeUpdated'],
  [ErrorCode.LIQUID_OUTPUT_CAN_NOT_BE_CREATED, 'error_liquidOutputCannotBeCreated'],
  [ErrorCode.LIQUID_OUTPUT_CAN_NOT_BE_DELETED, 'error_liquidOutputCannotBeDeleted'],
  [ErrorCode.LIQUID_OUTPUT_NOT_FOUND, 'error_liquidOutputNotFound'],
  [ErrorCode.MEAL_CAN_NOT_BE_CREATED, 'error_mealCannotBeCreated'],
  [ErrorCode.MEAL_CAN_NOT_BE_DELETED, 'error_mealCannotBeDeleted'],
  [ErrorCode.MEAL_NOT_FOUND, 'error_mealNotFound'],
  [ErrorCode.MEAL_CAN_NOT_BE_UPDATED, 'error_mealCannotBeUpdated'],
  [ErrorCode.VISIT_SHEET_NOT_FOUND, 'error_visitSheetNotFound'],
  [ErrorCode.VISIT_SHEET_CAN_NOT_BE_CREATED, 'error_visitSheetCannotBeCreated'],
  [ErrorCode.VISIT_SHEET_CAN_NOT_BE_UPDATED, 'error_visitSheetCannotBeUpdated'],
  [ErrorCode.VISIT_SHEET_CAN_NOT_BE_DELETED, 'error_visitSheetCannotBeDeleted'],
  [ErrorCode.IMMUTABLE_DATA, 'error_immutableData'],
  [ErrorCode.TIMEFRAME_EXCEEDED, 'error_timeframeExceeded'],
  [ErrorCode.PAIN_NOT_FOUND, 'error_painNotFound'],
  [ErrorCode.PAIN_CAN_NOT_BE_CREATED, 'error_painCannotBeCreated'],
  [ErrorCode.PAIN_CAN_NOT_BE_UPDATED, 'error_painCannotBeUpdated'],
  [ErrorCode.PAIN_CAN_NOT_BE_DELETED, 'error_painCannotBeDeleted'],
  [ErrorCode.PAIN_ASSESSMENT_NOT_FOUND, 'error_painAssessmentNotFound'],
  [ErrorCode.PAIN_ASSESSMENT_CAN_NOT_BE_CREATED, 'error_painAssessmentCannotBeCreated'],
  [ErrorCode.PAIN_ASSESSMENT_CAN_NOT_BE_UPDATED, 'error_painAssessmentCannotBeUpdated'],
  [ErrorCode.PAIN_ASSESSMENT_CAN_NOT_BE_DELETED, 'error_painAssessmentCannotBeDeleted'],
  [ErrorCode.PAIN_ASSESSMENT_IDS_COULD_NOT_BE_SAVED, 'error_painAssessmentIdsCouldNotBeSaved'],
  [ErrorCode.HINTS_CONFIG_NOT_FOUND, 'error_hintsConfigNotFound'],
  [ErrorCode.HINTS_CONFIG_CAN_NOT_BE_CREATED, 'error_hintsConfigCannotBeCreated'],
  [ErrorCode.HINTS_CONFIG_CAN_NOT_BE_DELETED, 'error_hintsConfigCannotBeDeleted'],
  [ErrorCode.ON_DEMAND_MEDICATION_CAN_NOT_BE_CREATED, 'error_medicationCannotBeCreated'],
  [ErrorCode.ON_DEMAND_MEDICATION_NOT_FOUND, 'error_medicationNotFound'],
  [ErrorCode.ON_DEMAND_MEDICATION_CAN_NOT_BE_UPDATED, 'error_medicationCannotBeUpdated'],
  [ErrorCode.GENERAL_ORDER_CAN_NOT_BE_UPDATED, 'error_generalOrderCannotBeUpdated'],
  [ErrorCode.GENERAL_ORDER_NOT_FOUND, 'error_generalOrderNotFound'],
  [ErrorCode.GENERAL_ORDER_CAN_NOT_BE_DELETED, 'error_generalOrderCannotBeDeleted'],
  [ErrorCode.GENERAL_ORDER_CAN_NOT_BE_CREATED, 'error_generalOrderCannotBeCreated'],
  [ErrorCode.INSULIN_MEDICATION_NOT_FOUND, 'error_insulinMedicationNotFound'],
  [ErrorCode.INSULIN_MEDICATION_CAN_NOT_BE_CREATED, 'error_insulinMedicationCannotBeCreated'],
  [ErrorCode.INSULIN_MEDICATION_CAN_NOT_BE_UPDATED, 'error_insulinMedicationCannotBeUpdated'],
  [ErrorCode.CONSTANT_MEDICATION_NOT_FOUND, 'error_constantMedicationNotFound'],
  [ErrorCode.CONSTANT_MEDICATION_CAN_NOT_BE_CREATED, 'error_constantMedicationCannotBeCreated'],
  [ErrorCode.CONSTANT_MEDICATION_CAN_NOT_BE_UPDATED, 'error_constantMedicationCannotBeUpdated'],
  [ErrorCode.RESIDENT_ADVICE_CONSULTATION_NOT_FOUND, 'error_residentAdviceConsultationNotFound'],
  [
    ErrorCode.RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_CREATED,
    'error_residentAdviceConsultationCannotBeCreated',
  ],
  [
    ErrorCode.RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_UPDATED,
    'error_residentAdviceConsultationCannotBeUpdated',
  ],
  [
    ErrorCode.RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_DELETED,
    'error_residentAdviceConsultationCannotBeDeleted',
  ],
  [
    ErrorCode.RESIDENT_ADVICE_CONSULTATION_CAN_NOT_BE_RESTORED,
    'error_residentAdviceConsultationCannotBeRestored',
  ],
  [ErrorCode.RESIDENT_CHECKLIST_NOT_FOUND, 'error_residentChecklistNotFound'],
  [ErrorCode.RESIDENT_CHECKLIST_CAN_NOT_BE_CREATED, 'error_residentChecklistCannotBeCreated'],
  [ErrorCode.RESIDENT_CHECKLIST_CAN_NOT_BE_UPDATED, 'error_residentChecklistCannotBeUpdated'],
  [ErrorCode.RESIDENT_CHECKLIST_CAN_NOT_BE_DELETED, 'error_residentChecklistCannotBeDeleted'],
  [ErrorCode.RESIDENT_CHECKLIST_CAN_NOT_BE_RESTORED, 'error_residentChecklistCannotBeRestored'],
  [
    ErrorCode.RESIDENT_DOCUMENTMANAGEMENT_CAN_NOT_BE_CREATED,
    'error_residentDocumentmanagementCannotBeCreated',
  ],
  [
    ErrorCode.RESIDENT_DOCUMENTMANAGEMENT_FILE_ALREADY_EXISTS,
    'error_residentDocumentmanagementFileAlreadyExists',
  ],
  [ErrorCode.RESIDENT_DOCUMENTMANAGEMENT_NOT_FOUND, 'error_residentDocumentmanagementNotFound'],
  [
    ErrorCode.RESIDENT_DOCUMENTMANAGEMENT_CANNOT_BE_DELETED,
    'error_residentDocumentmanagementCannotBeDeleted',
  ],
  [
    ErrorCode.RESIDENT_DOCUMENTMANAGEMENT_CANNOT_BE_UPDATED,
    'error_residentDocumentmanagementCannotBeUpdated',
  ],
  [ErrorCode.PASTORAL_CARE_NOT_FOUND, 'error_PastoralCareNotFound'],
  [ErrorCode.PASTORAL_CARE_CAN_NOT_BE_CREATED, 'error_PastoralCareCannotBeCreated'],
  [ErrorCode.PASTORAL_CARE_CAN_NOT_BE_UPDATED, 'error_PastoralCareCannotBeUpdated'],
  [ErrorCode.PASTORAL_CARE_CAN_NOT_BE_DELETED, 'error_PastoralCareCannotBeDeleted'],
  [ErrorCode.PASTORAL_CARE_CAN_NOT_BE_RESTORED, 'error_PastoralCareCannotBeRestored'],
  [ErrorCode.DOCTOR_CAN_NOT_BE_UPDATED, 'error_doctorCannotBeUpdated'],
  [ErrorCode.DOCTOR_CAN_NOT_BE_DELETED, 'error_doctorCannotBeDeleted'],
  [ErrorCode.UTENSILS_NOT_FOUND, 'error_UtensilsNotFound'],
  [ErrorCode.UTENSILS_CAN_NOT_BE_CREATED, 'error_UtensilsCannotBeCreated'],
  [ErrorCode.UTENSILS_CAN_NOT_BE_UPDATED, 'error_UtensilsCannotBeUpdated'],
  [ErrorCode.UTENSILS_CAN_NOT_BE_DELETED, 'error_UtensilsCannotBeDeleted'],
  [ErrorCode.UTENSILS_CAN_NOT_BE_RESTORED, 'error_UtensilsCannotBeRestored'],
  [ErrorCode.RESIDENT_CONTRACT_NOT_FOUND, 'error_residentContractNotFound'],
  [ErrorCode.RESIDENT_CONTRACT_CAN_NOT_BE_CREATED, 'error_residentContractCannotBeCreated'],
  [ErrorCode.RESIDENT_CONTRACT_CAN_NOT_BE_UPDATED, 'error_residentContractCannotBeUpdated'],
  [ErrorCode.RESIDENT_CONTRACT_CAN_NOT_BE_RESTORED, 'error_residentContractCannotBeRestored'],
  [ErrorCode.RESIDENT_CONTRACT_CAN_NOT_BE_DELETED, 'error_residentContractCannotBeDeleted'],
  [ErrorCode.EXECUTION_PROOF_NO_PERMISSION, 'error_executionProofNoPermission'],
  [ErrorCode.NURSING_TASK_CANNOT_BE_CREATED, 'error_dataCannotBeCreated'],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_NO_PERMISSION,
    'error_nursingTaskDocumentationNoPermission',
  ],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_CANNOT_BE_UPDATED,
    'error_nursingTaskDocumentationCannotBeUpdated',
  ],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_IN_FUTURE_CANNOT_BE_UPDATED,
    'error_nursingTaskDocumentationInFutureCannotBeUpdated',
  ],
  [ErrorCode.NURSING_TASK_DOCUMENTATION_CANNOT_BE_CREATED, 'error_dataCannotBeCreated'],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_CANNOT_BE_CREATED_DUPLICATE,
    'error_nursingTaskDocumentationCannotBeCreated_duplicate',
  ],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_OLDER_OPEN_TASK_EXISTS,
    'error_nursingTaskDocumentationOlderOpenTaskExists',
  ],
  [ErrorCode.NURSING_TASK_DOCUMENTATION_CANNOT_BE_DELETED, 'error_dataCannotBeDeleted'],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_CANNOT_BE_REVERTED,
    'error_nursingTaskDocumentationCannotBeReverted',
  ],
  [
    ErrorCode.NURSING_TASK_DOCUMENTATION_WITH_FUTURE_TASK_CANNOT_BE_REVERTED,
    'error_nursingTaskDocumentationWithFutureTaskCannotBeReverted',
  ],
  [ErrorCode.TIMEOS_ROOT_UNIT_DOES_NOT_EXIST, 'error_timeosRootUnitDoesNotExist'],
  [ErrorCode.MOVEMENT_STATUS_CAN_NOT_BE_CREATED, 'error_movementStatusCannotBeCreated'],
  [ErrorCode.MOVEMENT_STATUS_NOT_FOUND, 'error_movementStatusNotFound'],
  [ErrorCode.MOVEMENT_STATUS_CAN_NOT_BE_UPDATED, 'error_movementStatusCannotBeUpdated'],
  [ErrorCode.MOVEMENT_STATUS_CAN_NOT_BE_DELETED, 'error_movementStatusCannotBeDeleted'],
  [ErrorCode.HOSPITAL_EXPORT_PDF_NOT_FOUND, 'error_hospitalExportPdfNotFound'],
  [ErrorCode.HOSPITAL_EXPORT_PDF_CAN_NOT_BE_CREATED, 'error_hospitalExportPdfCannotBeCreated'],
  [ErrorCode.HOSPITAL_EXPORT_PDF_CAN_NOT_BE_UPDATED, 'error_hospitalExportPdfCannotBeUpdated'],
  [ErrorCode.HOSPITAL_EXPORT_PDF_CAN_NOT_BE_DELETED, 'error_hospitalExportPdfCannotBeDeleted'],
  [ErrorCode.IDENTIFIER_COULD_NOT_BE_VALIDATED, 'error_identifierCouldNotBeValidated'],
  [ErrorCode.IDENTIFIER_IS_ALREADY_USED, 'error_identifierIsAlreadyUsed'],
  [ErrorCode.WOUND_NOT_FOUND, 'error_woundNotFound'],
  [ErrorCode.WOUND_THERAPY_NOT_FOUND, 'error_woundTherapyNotFound'],
  [ErrorCode.DELETION_NOT_ALLOWED, 'error_deletionNotAllowed'],
  [ErrorCode.WOUND_REPORT_NOT_FOUND, 'error_woundReportNotFound'],
  [ErrorCode.WOUND_THERAPY_CANNOT_BE_UPDATED, 'error_woundTherapyCannotBeUpdated'],
  [ErrorCode.WOUND_CANNOT_BE_DELETED, 'error_woundCannotBeDeleted'],
  [ErrorCode.LAST_WOUND_DESCRIPTION_CANNOT_BE_DELETED, 'error_lastWoundDescriptionCannotBeDeleted'],
  [ErrorCode.WOUND_CANNOT_BE_UPDATED, 'error_woundCannotBeUpdated'],
  [ErrorCode.WOUND_DESCRIPTION_CANNOT_BE_UPDATED, 'error_woundDescriptionCannotBeUpdated'],
  [ErrorCode.WOUND_THERAPY_CANNOT_BE_DELETED, 'error_woundTherapyCannotBeDeleted'],
  [ErrorCode.WOUND_ATTACHMENT_CAN_NOT_BE_CREATED, 'error_woundAttachmentCannotBeCreated'],
  [ErrorCode.WOUND_ATTACHMENT_FILE_ALREADY_EXISTS, 'error_woundAttachmentFileAlreadyExists'],
  [ErrorCode.WOUND_ATTACHMENT_NOT_FOUND, 'error_woundAttachmentNotFound'],
  [ErrorCode.WOUND_ATTACHMENT_CANNOT_BE_DELETED, 'error_woundAttachmentCannotBeDeleted'],
  [ErrorCode.WOUND_ATTACHMENT_CANNOT_BE_UPDATED, 'error_woundAttachmentCannotBeUpdated'],
  [ErrorCode.DEADLINES_CAN_NOT_BE_CREATED, 'error_deadlinesCannotBeCreated'],
  [ErrorCode.DEADLINES_CAN_NOT_BE_UPDATED, 'error_deadlinesCannotBeUpdated'],
  [ErrorCode.DEADLINES_NOT_FOUND, 'error_deadlinesNotFound'],
  [ErrorCode.DEADLINES_CAN_NOT_BE_RETRIEVED_AQUA, 'error_deadlinesCanNotBeRetrievedAqua'],
  [ErrorCode.DEADLINES_CAN_NOT_BE_FILTERED, 'error_deadlinesCanNotBeFiltered'],
  [ErrorCode.INDICATOR_RECORD_CAN_NOT_BE_CREATED, 'error_indicatorRecordCanNotBeCreated'],
  [
    ErrorCode.INDICATOR_RESIDENT_RECORD_CAN_NOT_BE_CREATED,
    'error_indicatorResidentRecordCanNotBeCreated',
  ],
  [
    ErrorCode.INDICATOR_RESIDENT_RECORD_CAN_NOT_BE_CREATED_FROM_OVERVIEW,
    'error_indicatorResidentRecordCanNotBeCreated',
  ],
  [ErrorCode.INDICATORS_CAN_NOT_BE_PROCESSED, 'error_indicatorsCanNotBeProcessed'],
  [ErrorCode.INDICATORS_VALIDATION_PROTOCOL_ERROR, 'error_indicatorsValidationProtocolError'],
  [ErrorCode.INDICATORS_COMMENTATION_ERROR, 'error_indicatorsCommentationError'],
  [ErrorCode.COMMON_MEDICATION_NOT_FOUND, 'error_commonMedicationNotFound'],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_NOT_FOUND,
    'error_residentInsuranceInvoicingConfig_notFound',
  ],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_LOADED,
    'error_residentInsuranceInvoicingConfig_canNotBeLoaded',
  ],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_CREATED,
    'error_residentInsuranceInvoicingConfig_canNotBeCreated',
  ],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_DELETED,
    'error_residentInsuranceInvoicingConfig_canNotBeDeleted',
  ],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED,
    'error_residentInsuranceInvoicingConfig_canNotBeUpdated',
  ],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_DUPLICATE_DATE,
    'error_residentInsuranceInvoicingConfigDuplicateDate',
  ],
  [
    ErrorCode.RESIDENT_INSURANCE_INVOICING_CONFIG_NOT_MOST_RESENT,
    'error_residentInsuranceInvoicingConfig_notMostResent',
  ],
  [
    ErrorCode.RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_NOT_MOST_RESENT,
    'error_privatePayerInvoicingConfig_notMostResent',
  ],
  [ErrorCode.RESIDENT_WITH_INVOICE_CAN_NOT_BE_DELETED, 'error_residentWithInvoiceCanNotBeDeleted'],
  [ErrorCode.WOUND_THERAPY_ORDER_NOT_FOUND, 'error_WoundTherapyOrderNotFound'],
  [ErrorCode.WOUND_THERAPY_ORDER_CANNOT_BE_UPDATED, 'error_WoundTherapyOrderCannotBeUpdated'],
  [ErrorCode.WOUND_THERAPY_ORDER_CANNOT_BE_DELETED, 'error_WoundTherapyOrderCannotBeDeleted'],
  [ErrorCode.WOUND_THERAPY_ORDER_CANNOT_BE_CREATED, 'error_WoundTherapyOrderCannotBeCreated'],
  [ErrorCode.WELFARE_OFFICE_NOT_FOUND, 'error_welfareOfficeNotFound'],
  [ErrorCode.WELFARE_OFFICE_CAN_NOT_BE_CREATED, 'error_welfareOfficeCannotBeCreated'],
  [ErrorCode.WELFARE_OFFICE_CAN_NOT_BE_UPDATED, 'error_welfareOfficeCannotBeUpdated'],
  [ErrorCode.WELFARE_OFFICE_DUPLICATE_NAME, 'error_welfareOfficeDuplicateName'],
  [ErrorCode.WELFARE_OFFICE_DELETION_FAILED, 'error_welfareOfficeDeletionFailed'],
  [
    ErrorCode.WELFARE_OFFICE_CAN_NOT_BE_DELETED_AS_IN_USE,
    'error_welfareOfficeCannotBeDeletedAsInUse',
  ],
  [ErrorCode.WELFARE_OFFICES_CAN_NOT_BE_LOADED, 'error_welfareOfficeCannotBeLoaded'],
  [ErrorCode.USERNAME_ALREADY_EXISTS, 'error_userNameAlreadyExists'],
  [ErrorCode.SEPA_EXPORT_CAN_NOT_BE_SAVED, 'error_sepaExportCannotBeSaved'],
  [ErrorCode.SEPA_POCKET_NOT_FOUND, 'error_sepaPocketNotFound'],
  [ErrorCode.SEPA_POCKET_CAN_NOT_BE_SAVED, 'error_sepaPocketCanNotBeSaved'],
  [ErrorCode.SEPA_POCKET_CAN_NOT_BE_UPDATED, 'error_sepaPocketCanNotBeUpdated'],
  [ErrorCode.SEPA_POCKET_CAN_NOT_BE_DELETED, 'error_sepaPocketCanNotBeDeleted'],
  [
    ErrorCode.RESIDENT_INVOICING_REMARK_CAN_NOT_BE_FOUND,
    'error_residentInvoicingRemarkCanNotBeFound',
  ],
  [
    ErrorCode.RESIDENT_INVOICING_REMARK_CAN_NOT_BE_UPDATED,
    'error_residentInvoicingRemarkCanNotBeUpdated',
  ],
  [
    ErrorCode.RESIDENT_INVOICING_REMARK_CAN_NOT_BE_CREATED,
    'error_residentInvoicingRemarkCanNotBeCreated',
  ],
  [ErrorCode.COST_BEARER_BALANCE_CAN_NOT_BE_UPDATED, 'error_costBearerBalanceCannotBeUpdated'],
  [ErrorCode.FIBU_EXPORT_CAN_NOT_BE_SAVED, 'error_fibuExportCannotBeSaved'],
  [ErrorCode.DOCUMENT_TEMPLATE_NOT_FOUND, 'error_documentTemplateNotFound'],
  [ErrorCode.DOCUMENT_TEMPLATE_CAN_NOT_BE_CREATED, 'error_documentTemplateCanNotBeCreated'],
  [ErrorCode.DOCUMENT_TEMPLATE_CANNOT_BE_DELETED, 'error_documentTemplateCanNotBeDeleted'],
  [ErrorCode.DOCUMENT_TEMPLATE_CANNOT_BE_UPDATED, 'error_documentTemplateCanNotBeUpdated'],
  [ErrorCode.DOCUMENT_TEMPLATE_FILE_ALREADY_EXISTS, 'error_documentTemplateFileAlreadyExists'],
  [
    ErrorCode.RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_LOADED,
    'error_residentWelfareOfficeInvoicingConfigCanNotBeLoaded',
  ],
  [
    ErrorCode.RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_CAN_NOT_BE_UPDATED,
    'error_residentWelfareOfficeInvoicingConfigCanNotBeUpdated',
  ],
  [
    ErrorCode.RESIDENT_WELFARE_OFFICE_INVOICING_CONFIG_DUPLICATE_DATE,
    'error_residentWelfareOfficeInvoicingConfigDuplicateDate',
  ],
  [
    ErrorCode.RESIDENT_DOCUMENT_GENERATION_CAN_NOT_BE_CREATED,
    'error_residentDocumentGenerationCanNotBeCreated',
  ],
  [
    ErrorCode.RESIDENT_DOCUMENT_GENERATION_FILE_ALREADY_EXISTS,
    'error_residentDocumentGenerationFileAlreadyExists',
  ],
  [ErrorCode.RESIDENT_DOCUMENT_GENERATION_NOT_FOUND, 'error_residentDocumentGenerationNotFound'],
  [
    ErrorCode.RESIDENT_DOCUMENT_GENERATION_CANNOT_BE_DELETED,
    'error_residentDocumentGenerationCanNotBeDeleted',
  ],
  [
    ErrorCode.RESIDENT_DOCUMENT_GENERATION_INVALID_CODE,
    'error_residentDocumentGenerationInvalidCode',
  ],
  [
    ErrorCode.RESIDENT_DOCUMENT_GENERATION_CANNOT_BE_UPDATED,
    'error_residentDocumentGenerationCanNotBeUpdated',
  ],
  [ErrorCode.RESIDENT_OCCUPANCY_CAN_NOT_BE_RETRIEVED, 'error_residentOccupancyCanNotBeLoaded'],
  [
    ErrorCode.RESIDENT_PRIVATE_PAYER_INVOICING_CONFIG_CAN_NOT_BE_LOADED,
    'error_residentPrivatePayerInvoicingConfigCanNotBeLoaded',
  ],
]);
